/** Positions (job ad listing) domain storage. Per-tab (sessionStorage) search state and arrow-navigation batch/paging. */
import Storage from '../index';
import StorageKeys from '../keys';

const positions = {
    getSearchState: (lang) => Storage.get(StorageKeys.positionsSearchState(lang), null),
    setSearchState: (lang, state) => Storage.set(StorageKeys.positionsSearchState(lang), state),

    getResultBatch: () => Storage.get(StorageKeys.positionsBatch, null),
    setResultBatch: (hashes) => Storage.set(StorageKeys.positionsBatch, hashes),

    getResultPaging: () => Storage.get(StorageKeys.positionsPaging, null),
    setResultPaging: (paging) => Storage.set(StorageKeys.positionsPaging, paging),
};

export default positions;
